export const pluralize = (
  number: number,
  one: string,
  two: string,
  five: string
): string => {
  number = Math.abs(number);
  number %= 100;
  if (number >= 5 && number <= 20) {
    return five;
  }
  number %= 10;
  if (number === 1) {
    return one;
  }
  if (number >= 2 && number <= 4) {
    return two;
  }
  return five;
};

export type AddressInput =
  | Entity.Address
  | Entity.AddressSuggestion
  | string
  | null;

/* todo: refactor */
export function formattedAddress(
  address: AddressInput,
  short: boolean
): string {
  if (typeof address === "object" && address !== null) {
    if (address.city && address.street && address.houseNumber) {
      let result = "";
      if (short) {
        result = `${address.city}, ${address.street}, ${address.houseNumber}`;
      } else {
        result = `${address.city}, ${address.street}, дом ${address.houseNumber}`;
        if (
          !(
            result.includes("село") ||
            result.includes("с ") ||
            result.includes("с.") ||
            result.includes("район") ||
            result.includes("край") ||
            result.includes("пос") ||
            result.includes("п") ||
            result.includes("пос.") ||
            result.includes("п.") ||
            result.includes("поселок") ||
            result.includes("станция") ||
            result.includes("ст") ||
            result.includes("ст. ")
          )
        ) {
          result = `г. ${result}`;
        }
      }
      return result;
    } else {
      if (address.formattedAddress) {
        return address.formattedAddress;
      }
    }
  }
  if (typeof address === "string") {
    return address;
  }
  return "";
}

export function formattedDeliveryInfo(
  type: Entity.PreOrder.DeliveryType | Entity.Cart.ReceiveType
) {
  return type === "booking" ? "Заказ хранится 24 часа" : "Заказ хранится 3 дня";
}

export function formattedPhone(phone: string) {
  if (typeof phone !== "string") return "";
  const newFormat = phone.includes("доб")
    ? "$1 ($2) $3-$4-$5 доб. $6"
    : "$1 ($2) $3-$4-$5";
  const value = phone
    .replace(/\D/g, "")
    .replace(
      /(7|8)[\s(]?(\d{3})[\s)]?(\d{3})[\s-]?(\d{2})[\s-]?(\d{2})?([\s-]\d)?/g,
      newFormat
    );

  return value ? value : "";
}

export const plainPhone = (phone: string) => {
  if (typeof phone !== "string") return "";

  return phone.replace(/\D/g, "").slice(1);
};

export function capitalize(string: string): string {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function truncateText(text: string, limit = 35): string {
  if (!text || typeof text !== "string") return "";

  if (text.length <= limit) return text;
  const currentLimit = limit - 3 > 0 ? limit - 3 : limit;

  const currentText = text.slice(0, currentLimit);

  return `${currentText}...`;
}
